import { AssociatedAggregate, DeepDiveV3Request } from '@blk/awt-aladdinwealthserver';
import { CancelToken } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { normalizeNullValuesForAGraph } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awApiWithPkg } from './Base';

export async function postAwAggregate(request: DeepDiveV3Request, cancelToken?: CancelToken) {
  // v3/ does not support joint accounts
  const path = 'api/v3/deep-dive';
  let newRequest = request;
  if (isAGraphEnabled()) {
    newRequest = normalizeNullValuesForAGraph(newRequest, 'accountIDEntity');
    if (newRequest.rollupEntities) {
      newRequest = {
        ...newRequest,
        rollupEntities: newRequest.rollupEntities.map((entity) => normalizeNullValuesForAGraph(entity)),
      };
    }
  }
  const response = await awApiWithPkg.post<AGraphWrappedType<AssociatedAggregate[], 'items'>>(path, newRequest, {
    cancelToken,
    params: { pkg: request.pkg },
  });
  return unwrapAGraphResponse(response, 'items');
}
